import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

// const API_URL = 'https://localhost:9090/api/all/';
import baseUrl from '../base-url';

const API_URL = baseUrl() + "/api/all/";

const getDataPeserta = 'data-peserta-sertifikasi-rpl/index';
const getDataPesertaRPL = 'data-peserta-sertifikasi-rpl/index';
const exportDataPeserta = 'data-peserta/data-peserta-sertifikasi/export';
const getSertifikasi = 'sertifikasi';
const detailDataPeserta = 'jadwal-test-center/dokumen-pendukung-peserta-sertifikasi-new/';
const ProsesAdministrasiUrl = 'data-peserta/sertifikasi-peserta/proses-administrasi/'
const getMataUjiPesertaSertifikasi = 'data-peserta/data-peserta-sertifikasi/mata-uji-peserta';
const putStatusPembatalan = 'data-peserta/sertifikasi-peserta/edit-status-pembatalan/';
const getDetailReschedule = 'data-peserta/data-peserta-sertifikasi/mata-uji-peserta/reschedule/';
const putReschedule = 'data-peserta/data-peserta-sertifikasi/mata-uji-peserta/reschedule/';
const putStatusRefundMataUjiPeserta = 'data-peserta/data-peserta-sertifikasi/mata-uji-peserta/refund/'
const getDataPesertaSertifikasi = 'data-peserta-sertifikasi/index';

// data-peserta-sertifikasi/mata-uji-peserta?pageNo=0&pageSize=10&filter=default&idSertifikasiPeserta=c596ea99-94af-49e0-915a-52aa9830134a
class DataPesertaService {

    exportDataPeserta(
        periode,
        id_sertifikasi,
        status_pembayaran
    ) { 
        return axios.get(
            API_URL + exportDataPeserta,
            {
            params : {
                periode : periode,
                id_sertifikasi : id_sertifikasi,
                status_pembayaran : status_pembayaran
            },
            headers: { 'Content-Type': 'application/octet-stream','Authorization' : tokenHeader() },
            responseType: 'blob'
        });
    }

    getDataPesertaSertifikasi(
        currentPage,
        pageSize,
        statusPembayaran,
        periode, 
        namaPeserta,
        level
    ) {
        return axios.get(API_URL + getDataPesertaSertifikasi, {
            params: {
                pageNo : currentPage,
                pageSize : pageSize,
                statusPembayaran : statusPembayaran,
                periode: periode, 
                namaPeserta:namaPeserta,
                level: level
            },
            headers: authHeader()
        });
    }

    getDataPeserta(
        currentPage,
        pageSize,
        filter,
        id_sertifikasi,
        status_pembayaran,
        tahun_daftar,
        startDate,
        endDate
    ) {
        var data = {
            pageNo : currentPage,
            pageSize : pageSize,
            filter : filter,
            id_sertifikasi : id_sertifikasi,
            status_pembayaran : status_pembayaran,
            periode : tahun_daftar,
            startDate : startDate,
            endDate : endDate
        }
        return axios.get(
            API_URL + getDataPeserta,
            {
                params : data,
                headers: authHeader()
            });
    }

    getDataPesertaRPL(
        currentPage,
        pageSize,
        filter,
        id_sertifikasi,
        status_pembayaran,
        tahun_daftar,
        startDate,
        endDate
    ) {
        var data = {
            pageNo : currentPage,
            pageSize : pageSize,
            filter : filter,
            id_sertifikasi : id_sertifikasi,
            status_pembayaran : status_pembayaran,
            periode : tahun_daftar,
            startDate : startDate,
            endDate : endDate
        }
        return axios.get(
            API_URL + getDataPesertaRPL,
            {
                params : data,
                headers: authHeader()
            });
    }

    getDetailReschedule(id_mata_uji_peserta) {
        return axios.get(
            API_URL + getDetailReschedule + id_mata_uji_peserta,
        {
            headers: authHeader()
        });
    }

    putStatusReschedule(data) {
        return axios
        .put(
            API_URL + putReschedule + data.id_mata_uji_peserta,
            data,
            { headers: authHeader() }
        );
    }

    putStatusRefundMataUjiPeserta(data) {
        return axios
        .put(
            API_URL + putStatusRefundMataUjiPeserta + data.id_mata_uji_peserta,
            data,
            { headers: authHeader() }
        );
    }

    putStatusPembatalan(data) {
        return axios.put(
            API_URL + putStatusPembatalan + data.id_sertifikasi_peserta,
            data,
            { headers: authHeader() }
        );
    }

    getMataUjiPesertaSertifikasi(currentPage, pageSize, filter, id_sertifikasi_peserta)
    {
        return axios.get(
        API_URL + getMataUjiPesertaSertifikasi + '?pageNo=' + currentPage + '&pageSize=' + pageSize + '&filter=' + filter + '&idSertifikasiPeserta=' + id_sertifikasi_peserta,
        {
            headers: authHeader()
        });
    }

    getSertifikasi() {
        return axios.get(
            API_URL + getSertifikasi + '?pageNo=0&pageSize='+10000000000+'&filter=default', {
            headers: authHeader()
        });

    }

    detailDataPeserta(idPelatihanPeserta) {
        return axios
            .get(
                API_URL + detailDataPeserta + idPelatihanPeserta,
                { headers: authHeader() }
            );
    }

    putSendProsesAdministrasiRpl(formProsesAdministrasi) {
        var headers = authHeader();

        return axios
        .put(
            API_URL + ProsesAdministrasiUrl + formProsesAdministrasi.idSertifikasiPeserta,
            formProsesAdministrasi,
            { headers: { 'Content-Type': 'application/json','Authorization' : tokenHeader() } }
        );
    }

}

export default new DataPesertaService();